import client from './client'
import * as transform from './transform'

const legacyGetHomeDetail = homeId =>
  client.get(`/api/v1/homes/${homeId}/detailed?app=HomebotClients`)

const legacyUpdateHome = (homeId, data) =>
  client.post(`/api/v1/homes/${homeId}/updateHome`, { data })

const legacyAddHomeAnswer = ({ id: homeId, answerData: data }) =>
  client.post(`/api/v1/homes/${homeId}/addAnswer`, data)

export const legacyUpdateLoan = (loanId, data) =>
  client.put(`/api/v1/homeLoans/${loanId}/editLoan?app=HomebotClients`, {
    data: transform.loan(data)
  })

export const legacyCreateLoan = (homeId, data) =>
  client.post(`/api/v1/homes/${homeId}/createLoan?app=HomebotClients`, {
    data: transform.loan(data)
  })

export const getHomeDetail = transform.homeDetail(legacyGetHomeDetail)

export const updateHome = legacyUpdateHome

export const addHomeAnswer = legacyAddHomeAnswer

export const messageSponsor = (homeId, data) =>
  client.post(
    `/api/v1/homes/${homeId}/messageSponsor`,
    transform.messageSponsor(data)
  )

export const messageAgent = (homeId, data) =>
  client.post(
    `/api/v1/homes/${homeId}/messageAgent`,
    transform.messageAgent(data)
  )

export const requestEmail = (homeId, email) =>
  client.noAuthorization.post(`/api/v1/homes/${homeId}/requestEmail`, { email })
